<template>
  <div>
    <Card>
      <ui-phone-input
        v-model="phoneNumber"
        :label="t('Phone number') + '*'"
      ></ui-phone-input>
    </Card>
    <Card>
      <ui-phone-input
        v-model="phoneNumber"
        :label="t('Phone number') + '*'"
        :error-messages="['phoneNumber']"
      ></ui-phone-input>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';
import { useI18n } from '@/composables';

const { t } = useI18n();
const phoneNumber = ref('');
</script>
